export type TeamChipKey = 'active' | 'pending' | 'expired' | 'requested' | 'deactivated'

export type MemberChipKey = Extract<TeamChipKey, 'active' | 'deactivated'>
export type InviteChipKey = Extract<TeamChipKey, 'pending' | 'expired' | 'requested'>

export interface TeamChipDefinition {
  key: TeamChipKey
  label: string
  source: 'member' | 'invite'
}

export type MemberChipDefinition = TeamChipDefinition & { key: MemberChipKey; source: 'member' }
export type InviteChipDefinition = TeamChipDefinition & { key: InviteChipKey; source: 'invite' }

export const DEFAULT_TEAM_CHIP: TeamChipKey = 'active'

const ACTIVE_CHIP: MemberChipDefinition = { key: 'active', label: 'Active', source: 'member' }
const DEACTIVATED_CHIP: MemberChipDefinition = { key: 'deactivated', label: 'Deactivated', source: 'member' }
const PENDING_CHIP: InviteChipDefinition = { key: 'pending', label: 'Pending', source: 'invite' }
const EXPIRED_CHIP: InviteChipDefinition = { key: 'expired', label: 'Expired', source: 'invite' }
const REQUESTED_CHIP: InviteChipDefinition = { key: 'requested', label: 'Requested', source: 'invite' }

export const MEMBER_TEAM_CHIPS: MemberChipDefinition[] = [ACTIVE_CHIP, DEACTIVATED_CHIP]
export const INVITE_TEAM_CHIPS: InviteChipDefinition[] = [PENDING_CHIP, EXPIRED_CHIP, REQUESTED_CHIP]

export const TEAM_CHIPS: TeamChipDefinition[] = [ACTIVE_CHIP, PENDING_CHIP, EXPIRED_CHIP, REQUESTED_CHIP, DEACTIVATED_CHIP]

export const visibleTeamChips = (hasInviteScope: boolean): TeamChipDefinition[] => TEAM_CHIPS.filter((chip) => hasInviteScope || chip.source === 'member')

export const resolveTeamChip = (value: string | null | undefined, hasInviteScope: boolean): TeamChipKey =>
  visibleTeamChips(hasInviteScope).find((chip) => chip.key === value)?.key ?? DEFAULT_TEAM_CHIP

export const isInviteChip = (chip: TeamChipKey): chip is InviteChipKey => INVITE_TEAM_CHIPS.some((definition) => definition.key === chip)
